import React from "react";
import Modal from "reactstrap/lib/Modal";
import ModalBody from "reactstrap/lib/ModalBody";
import "./style.css";
import Editor from "../TET/Editor";

const EditModal = ({
  isModalOpen,
  toggleYes,
  toggleCancel,
  text,
  handleTextChange,
}) => {
  return (
    <Modal
      className="adminConfirmation-popup-modal"
      isOpen={isModalOpen}
      backdrop
      keyboard={false}
      wrapClassName="modal-primary"
      size="lg"
    >
      <ModalBody>
        <div className="adminConfirmationModal-modal-body-content ami_editor">
          <Editor textState={text} onTextChange={handleTextChange} />
        </div>
        <div className="adminConfirmationModal-popup-button">
          <button
            type="button"
            onClick={toggleYes}
            className="btn btn-primary adminConfirmationModal-button btn-rounded"
          >
            Save
          </button>
          <button
            type="button"
            onClick={toggleCancel}
            className="btn btn-primary adminConfirmationModal-button btn-rounded"
          >
            Cancel
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default EditModal;



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/AMI/EditModal.js